import React, { useEffect, useRef } from "react";
import { MatApoyo } from "../Generals";

export default function Lesson5({ data }) {
  const isMounted = useRef(true);


  //Para desmontar el componente
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div className="texto_parrafo">
      <p>
        Ahora que ya conoces las actividades que se realizan en el proceso electoral, es muy importante que sepas cómo el INE promueve los 
        derechos humanos en materia político-electoral y garantiza su ejercicio en igualdad de condiciones, sin ningún tipo de discriminación, 
        ya sea por <b>identidad de género, orientación sexual, expresión de género, apariencia, edad, cualquier tipo de discapacidad, 
        origen étnico, situación migratoria o por cualquier otra condición.</b> 
      </p>
      <p>
        Por ello se han aprobado e implementado instrumentos aplicables en todos los procesos electorales y mecanismos de participación 
        ciudadana, a continuación, te los presentamos:
      </p>
      <p>
        <ol className="listNumber">
          <li>
            El "Protocolo para la Inclusión de las Personas con Discapacidad como funcionarios y funcionarias de Mesas Directivas de Casilla", 
            al que llamaremos <b>Protocolo para funcionariado de casilla con discapacidad</b> y cuyas medidas de inclusión puedes ver en el 
            material de apoyo: 
            <br/><br/>
            {data && data.indexOf(0) && <MatApoyo array={[data[0]]} />}
          </li>
          <li>
            Procedimiento para garantizar la participación como FMDC de las personas con doble nacionalidad que no hablan y/o escriben en español.
            Las medidas consisten en que a estas personas se les entregará un tríptico con la información en idioma inglés; se les comunicará sobre 
            la medida de acompañamiento para la traducción, la cual puede ser utilizada durante la capacitación y/o durante la Jornada Electoral; 
            en caso de requerir dicha medida, se llevará a cabo el procedimiento de acompañamiento establecido en el Protocolo para el funcionariado 
            de casilla con discapacidad.
          </li>
          <li>El “Protocolo para adoptar las medidas tendientes a garantizar a las personas trans el ejercicio del voto en igualdad de 
            condiciones y sin discriminación en todos los tipos de elección y mecanismos de participación ciudadana”, al que 
            llamaremos <b>Protocolo trans.</b> En el siguiente material te presentamos las medidas que establece dicho documento.
            <br/><br/>
            {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}
          </li>
          <li>El “Protocolo para la adopción de medidas tendientes a garantizar el derecho al voto y a la participación ciudadana de 
            las personas con discapacidad en los procesos electorales y mecanismos de participación ciudadana”, al que llamaremos 
            <b> Protocolo para garantizar el voto de personas con discapacidad.</b> Puedes revisar las medidas que establece en el siguiente 
            material de apoyo.
            <br/><br/>
            {data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}
          </li>
        </ol>
      </p>
      <p>
        También debes saber que para la elección de los domicilios en donde se ubicarán las casillas se priorizará aquellos que se 
        ubiquen en planta baja y en un terreno plano, además de incluir rampas y señalamientos para su ubicación, así como asegurar 
        que no presenten obstáculos naturales o artificiales que dificulten o impidan el acceso y tránsito de las personas con 
        discapacidad.
      </p>
      <p>
        En el siguiente enlace podrás reforzar las medidas de inclusión que se implementan durante el proceso electoral. 
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}<br/><br/>
      <p>
        Te invitamos a revisar con detenimiento los <b className="textoResaltado2">Protocolos de inclusión</b> que están disponibles en el material de consulta de este curso 
        y a observar los siguientes videos en los que se explican cómo se aplican las medidas de inclusión en el proceso electoral. 
      </p>
      {data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}<br/>
      {data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}<br/>
      {data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}<br/>
      <p>
        A continuación, revisa el siguiente material de apoyo para reforzar lo que aprendiste.
      </p>
      {data && data.indexOf(7) && <MatApoyo array={[data[7]]} />}
      <p>
        Para profundizar tus conocimientos sobre las medidas de inclusión durante el proceso electoral puedes revisar el 
        <b className="textoResaltado2"> CAPÍTULO 5 DE TU {data && data.indexOf(8) && <MatApoyo array={[data[8]]} tipo={1} />}</b> que 
        está disponible en los materiales de consulta de este curso.
      </p>
      <p>
      ¡Muy Bien! Concluiste este capítulo. No olvides realizar la actividad autoevaluable correspondiente para continuar con la 
      siguiente lección.
      </p>
    </div>
  );
}
